import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { DepartmentSer } from './Services/DepartmentService';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import axios from 'axios';

const DepartmentList = () => {
  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/vendor/apex/apexcharts.min.js',
      'assets/vendor/apex/custom/department/department-list.js',
      'assets/vendor/apex/custom/department/employees.js',
      'assets/vendor/datatables/dataTables.min.js',
      'assets/vendor/datatables/dataTables.bootstrap.min.js',
      'assets/vendor/datatables/custom/custom-datatables.js',
      'assets/js/custom.js'
    ];

    let isCancelled = false;

    // Load scripts sequentially
    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
      // Optionally remove scripts if needed
    };
  }, []);


  const navigator = useNavigate();
  const handleUpdateClick = (e, id) => {
    e.preventDefault();
    // Navigate to /page2 and pass the value
    navigator('/edit-departments', { state: { uata: id } });
    window.location.reload();
  };

  const handleDeleteConfirm = () => {
    // Send DELETE request to backend to delete the department
    axios.post(`http://localhost:8080/api/delete-department/${selectedDepartmentId}`)
      .then((response) => {
        // Update the departments list after deletion
        setDepartments(departments.filter(dept => dept.id !== selectedDepartmentId));
        alert('Department deleted successfully!');
      })
      .catch((error) => {
        console.error('Error deleting department:', error);
        alert('Failed to delete department');
      });
  };
  const handleEditClick = (id, dep_name) => {
    // Set the selected department ID and name for editing
    setSelectedDepartmentId(id);
    setDepartmentName(dep_name);
  };

  const handleEditConfirm = () => {
    // Send PUT request to backend to update the department name
    axios.put(`http://localhost:8080/api/update-department/${selectedDepartmentId}`, { dep_name: departmentName })
      .then((response) => {
        // Update the departments list with the edited department
        setDepartments(departments.map(dept => dept.id === selectedDepartmentId ? { ...dept, dep_name: departmentName } : dept));
        alert('Department updated successfully!');
      })
      .catch((error) => {
        console.error('Error updating department:', error);
        alert('Failed to update department');
      });
  };
  const handleDeleteAll = (e) => {
    e.preventDefault();
    // Show confirmation dialog
    const confirmDelete = window.confirm(
      `Are you sure you want to delete all items?`
    );

    if (confirmDelete) {
      // If confirmed, perform the delete action
      const REST_API_BASE_URL = `http://localhost:8080/api/deleteAllBooks`;

      axios
        .post(REST_API_BASE_URL)
        .then((response) => {
          console.log(response.data);
          window.alert(`This happend with: ${response.data}`);

          // After deletion, redirect to another page (e.g., home or item list)
          navigator("/departments-list"); // Navigates back to the homepage or another route
        })
        .catch((error) => {
          window.alert("Error occurred while deleting the item.");
          console.error(error);
        });
    } else {
      // If cancelled, do nothing (or show a cancellation message)
      window.alert("Deletion cancelled");
      navigator("/departments-list");
    }
  }
  const [departments, setDepartments] = useState([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(null); // For deleting or editing
  const [departmentName, setDepartmentName] = useState(''); // For editing
  
  useEffect(() => {
    axios.get('http://localhost:8080/api/department')
      .then(response => {
        setDepartments(response.data);
      })
      .catch(error => {
        console.error("Error fetching departments", error);
      });
  }, []);

  return (
    <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="index-2.html">
              <i className="ri-home-3-line" />
            </a>
          </li>
          <li className="breadcrumb-item">Department</li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Departments List
          </li>
        </ol>
        {/* Breadcrumb ends */}
        {/* Sales stats starts */}
        <div className="ms-auto d-lg-flex d-none flex-row">
          <div className="input-group">
            <span className="input-group-text bg-primary-lighten">
              <i className="ri-calendar-2-line text-primary" />
            </span>
            <input type="text" id="abc" className="form-control custom-daterange" />
          </div>
        </div>
        {/* Sales stats ends */}
      </div>
      {/* App Hero header ends */}
      {/* App body starts */}
      <div className="app-body">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-sm-6">
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="card-title">Departments</h5>
              </div>
              <div className="card-body">
                <div className="chart-height-lg">
                  <div id="total-department" className="auto-align-graph" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="card-title">Employees</h5>
              </div>
              <div className="card-body">
                <div className="chart-height-lg">
                  <div id="employees" className="auto-align-graph" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <h5 className="card-title">Department List</h5>
                <a href={"/add-departments"} className="btn btn-primary ms-auto">Add Department</a>
              </div>
              <div className="card-body">
                {/* Table starts */}
                <div className="table-responsive">
                  <table id="basicExample" className="table m-0 align-middle">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Department</th>
                        <th>Department Head</th>
                        <th>Doctors List</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {departments.map((dept, index) => (
                        <tr key={dept.id}>
                          <td>{index + 1}</td>
                          <td>{dept.dep_name}</td> {/* Ensure dept.dep_name exists */}
                          <td>
                            <div className="d-inline-flex gap-1">
                              
                              <button
                                className="btn btn-outline-success btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#editModules"
                                type="button"
                                onClick={() => {
                                  setSelectedDepartmentId(dept.id);
                                  setDepartments(dept.dep_name);
                                }}
                              >
                                <i className="ri-edit-box-line" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {/* Table ends */}
                {/* Modal Delete Row */}
                <div className="modal fade" id="delRow" tabIndex={-1} aria-labelledby="delRowLabel" aria-hidden="true">
                  <div className="modal-dialog modal-sm">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="delRowLabel">
                          Confirm
                        </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                      </div>
                      <div className="modal-body">
                        Are you sure you want to delete the department?
                      </div>
                      <div className="modal-footer">
                        <div className="d-flex justify-content-end gap-2">
                          <a href="#!" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">No</a>
                          <a href="/departments-list" className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={handleDeleteConfirm}>Yes</a>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
      {/* App body ends */}
    </div>
  );


}

export default DepartmentList;




